import React from "react";

import "./StoreAdminPage.css";

const StoreAdminPage = () => {
    return <div>Store Page div</div>;
};

export default StoreAdminPage;
